import React from 'react'
import propTypes from 'prop-types'
import sccssIcon from '../../../images/check.svg'
import Button from '../Button'

const SuccessModal = ({ size, center, msg, buttonText, t, handleClose, fillButton }) => (
  <>
    <div className={`custom-modal ${size} custom-success-modal center`}>
      <img src={sccssIcon} />
      <h4>{t('success')}</h4>
      {typeof msg === 'string' ? <span className={center && 'text-center'}>{msg}</span> : msg}
      <Button
        className={`btn btn-primary ${fillButton ? 'w-100' : 'half-w'}`}
        text={buttonText || t('close')}
        onClick={() => handleClose()}
      />
    </div>
    <div className='bg' onClick={() => handleClose()} />
  </>
)

SuccessModal.propTypes = {
  size: propTypes.string,
  handleClose: propTypes.func,
  msg: propTypes.string,
  t: propTypes.func,
  center: propTypes.bool,
  buttonText: propTypes.string,
  fillButton: propTypes.bool
}

export default SuccessModal
